"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _vehicleCompare = _interopRequireDefault(require("../vehicle-compare"));

var checkCarSelectorStep = function checkCarSelectorStep(selectedVehicle) {
  return selectedVehicle !== null;
};

var checkModelSelectStep = function checkModelSelectStep(models) {
  var modelsSelected = models.filter(function (model) {
    return model.selected === true;
  });

  if (modelsSelected.length > 0) {
    return true;
  }

  return false;
};

var getNextSteps = function getNextSteps(models, selectedVehicle, vehicleCompare) {
  // @Todo - cleanup after testing on dev
  console.log('vehicleCompareReducer', vehicleCompare);
  return {
    modelCompare: checkCarSelectorStep(selectedVehicle),
    comparison: checkModelSelectStep(models)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    nextSteps: getNextSteps(state.compareSelection.models, state.compareSelection.selectedVehicle, state.vehicleCompare),
    vehicleList: state.vehicleCompare.vehicleList,
    showVehicleList: state.vehicleCompare.showVehicleList
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_vehicleCompare["default"]);

exports["default"] = _default;